import React from 'react';

const Header = () => {
  return (
    <header className="py-6 bg-primary-white border-b border-gray-200">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="text-2xl font-bold">Kelton Oliveira</div>
        <div className="text-sm uppercase tracking-wider text-gray-600">Terapeuta | Palestrante | Autor</div>
      </div>
    </header>
  );
};

export default Header;
